/**
 * Created by l025351 on 12.09.2016.
 */

$.fn.dmsTablePlugin = function (options) {
    var pluginName = 'dmsTablePlugin';

    // default options.
    var settings = $.extend(
        {
            // These are the defaults.
        },
        options,
    );

    // Do something to each element here
    return this.each(function () {
        var dmsTable = $(this);

        // Write CSRF token from cookie to hidden input field, but only if it hasn't been set already
        const csrfToken = $.cookie('csrf');
        if (csrfToken) {
            $('input[name=csrf]').each((_, input) => {
                if (!input.getAttribute('value')) {
                    input.setAttribute('value', csrfToken);
                }
            });
        }

        const $buttons = $('.md-dms .row .col-2 button');
        $buttons.attr('aria-pressed', 'false');

        $buttons.on('click', function () {
            const $btn = $(this);

            $('.main-content > .container > .row > div.col-1:first-child').toggleClass('dms-fullscreen-col-1');
            $('.main-content > .container > .row > div.col-3').toggleClass('dms-fullscreen-col-3');

            const isFullscreen = $('.main-content > .container > .row > div.col-3').hasClass('dms-fullscreen-col-3');

            $btn.attr('aria-pressed', String(isFullscreen));
            $btn.find('.ic-zoomin, .ic-zoomout').toggleClass('ic-zoomin ic-zoomout');
        });

        var $liveStatusElement = $('#dms-live-status');
        var hasUserInteracted = false;

        var updateDebounced = debounce(function (inputValue) {
            var tableRows = dmsTable.find('tbody tr');

            if (inputValue === '') {
                tableRows.show();
                if (hasUserInteracted) {
                    announceLiveStatus($liveStatusElement, getFilterResultText($liveStatusElement, tableRows.length));
                }
                return;
            }

            hasUserInteracted = true;

            var data = inputValue.toUpperCase();
            tableRows.hide();

            var $matched = tableRows
                .filter(function () {
                    var $t = $(this);
                    var regex = new RegExp(data.replace(/\*/g, '.*'), 'g');
                    return regex.test($t.text().toUpperCase());
                })
                .show(); // show the rows that match.

            announceLiveStatus($liveStatusElement, getFilterResultText($liveStatusElement, $matched.length));
        }, 250);

        $(".md-dms input[type='text']").on('keyup input', function () {
            hasUserInteracted = true;

            var value = (this.value || '').trim();
            updateDebounced(value);
        });

        $('.md-dms #select-unselect-all').on('click', function () {
            $('.md-dms table td input[type="checkbox"]').prop('checked', $(this).prop('checked'));
        });

        $('.md-dms thead').on('click', 'th[aria-sort]', function () {
            var $th = $(this);

            setTimeout(function () {
                var sortState = $th.attr('aria-sort');

                if (!sortState || sortState === 'none') return;

                var columnName = $.trim($th.text());

                announceLiveStatus($liveStatusElement, getSortText($liveStatusElement, columnName, sortState));
            }, 10);
        });

        var $downloadForms = dmsTable.parents('.js-dms-download-form');
        if ($downloadForms) {
            $downloadForms.click(function (e) {
                if ($(e.target).hasClass('js-dms-download-form-checkbox') || $(e.target).hasClass('js-dms-download-form-checkbox-all')) {
                    $(this).find('.js-dms-download-form-validation-message').slideUp();
                }
            });

            $downloadForms.submit(function (e) {
                var checkedBoxes = $(this).find('.js-dms-download-form-checkbox:checked');
                if (checkedBoxes.length > 0) return;

                e.preventDefault();

                var $validationMessage = $(this).find('.js-dms-download-form-validation-message').first();
                if ($validationMessage.length === 0) {
                    $validationMessage = $(
                        '<p class="md-dms-download-form-validation-message js-dms-download-form-validation-message" aria-live="polite"></p>',
                    );
                    $(this).find('[type="submit"]').before($validationMessage);
                    $validationMessage.hide();
                    $validationMessage.slideDown();
                } else {
                    $validationMessage.slideDown();
                }

                // Timeout to let the screen reader read it
                setTimeout(function () {
                    $validationMessage.text($downloadForms.data('validation-message'));
                });
            });
        }
    });

    function announceLiveStatus($el, text) {
        if (!$el || !$el.length) return;

        $el.text('');
        setTimeout(function () {
            $el.text(text);
        }, 0);
    }

    function getFilterResultText($liveStatusElement, count) {
        var none = $liveStatusElement.data('result-none') || 'Keine Einträge gefunden.';
        var singular = $liveStatusElement.data('result-singular') || 'Eintrag gefunden.';
        var multiple = $liveStatusElement.data('result-plural') || 'Einträge gefunden.';

        if (count === 0) return none;
        if (count === 1) return '1 ' + singular;

        return count + ' ' + multiple;
    }

    function getSortText($liveStatusElement, columnLabel, ariaSortValue) {
        var asc = $liveStatusElement.data('sort-asc') || 'aufsteigend sortiert.';
        var desc = $liveStatusElement.data('sort-desc') || 'absteigend sortiert.';

        var dir = ariaSortValue === 'ascending' ? asc : desc;
        return columnLabel + ' ' + dir;
    }

    function debounce(fn, delay) {
        var t;
        return function () {
            var args = arguments;
            clearTimeout(t);
            t = setTimeout(function () {
                fn.apply(null, args);
            }, delay);
        };
    }
};
